/**
 * @Author: Tom Voorneveld <tom>
 * @Date:   2019-01-18T13:15:27+01:00
 * @Email:  tom@lorinthe.com
 * @Project: Lorinthe
  @Last modified by:   tom
  @Last modified time: 2019-06-12T16:47:21+02:00
 * @Copyright: (c) copyright Lorinthe BV, all rights reserved
 */

import uppercase from './_uppercase'
import currFor from './_currency-format'

export default {
  install (Vue) {
    Vue.filter('uppercase', uppercase)
    Vue.filter('formatCurrency', currFor)
  }
}
